import { createState } from '../context-utils';
import { CommandPaletteType } from './command-palette-types';

export const CommandPaletteShowSelector = createState((state: CommandPaletteType) => {
  return state.showCommandPalette;
});

export const CommandPaletteShowPopupSelector = createState((state: CommandPaletteType) => {
  return state.showPopUp;
});

export const CommandPaletteVendorSelector = createState((state: CommandPaletteType) => {
  return state.vendor;
});
